import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const auth = () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
};

export const feriaFotoPublicUrl = (archivo) => {
  if (!archivo || typeof archivo !== "string") return null;
  const base = (API_URL || "").replace(/\/$/, "");
  return `${base}/uploads/ferias/${encodeURIComponent(archivo)}`;
};

export const getFerias = async () => {
  const { data } = await axios.get(`${API_URL}/api/ferias`, {
    headers: auth(),
  });
  return data;
};

export const createFeria = async (body) => {
  const { data } = await axios.post(`${API_URL}/api/ferias`, body, {
    headers: auth(),
  });
  return data;
};

export const updateFeria = async (id, body) => {
  const { data } = await axios.put(`${API_URL}/api/ferias/${id}`, body, {
    headers: auth(),
  });
  return data;
};

export const deleteFeria = async (id) => {
  const { data } = await axios.delete(`${API_URL}/api/ferias/${id}`, {
    headers: auth(),
  });
  return data;
};

export const createFeriaEdicion = async (feriaId, body) => {
  const { data } = await axios.post(
    `${API_URL}/api/ferias/${feriaId}/ediciones`,
    body,
    { headers: auth() },
  );
  return data;
};

export const deleteFeriaEdicion = async (id) => {
  const { data } = await axios.delete(`${API_URL}/api/ferias/ediciones/${id}`, {
    headers: auth(),
  });
  return data;
};

export const getFeriaEdicion = async (id) => {
  const { data } = await axios.get(`${API_URL}/api/ferias/ediciones/${id}`, {
    headers: auth(),
  });
  return data;
};

export const updateFeriaEdicion = async (id, body) => {
  const { data } = await axios.put(
    `${API_URL}/api/ferias/ediciones/${id}`,
    body,
    { headers: auth() },
  );
  return data;
};

export const updateFeriaAsistentes = async (id, userIds) => {
  const { data } = await axios.put(
    `${API_URL}/api/ferias/ediciones/${id}/asistentes`,
    { userIds },
    { headers: auth() },
  );
  return data;
};

export const linkFeriaProveedor = async (edicionId, body) => {
  const { data } = await axios.post(
    `${API_URL}/api/ferias/ediciones/${edicionId}/proveedores`,
    body,
    { headers: auth() },
  );
  return data;
};

export const createFeriaProveedorNuevo = async (edicionId, body) => {
  const { data } = await axios.post(
    `${API_URL}/api/ferias/ediciones/${edicionId}/proveedores/nuevo`,
    body,
    { headers: auth() },
  );
  return data;
};

export const deleteFeriaProveedor = async (id) => {
  await axios.delete(`${API_URL}/api/ferias/proveedores/${id}`, {
    headers: auth(),
  });
};

export const updateFeriaProveedor = async (id, body) => {
  const { data } = await axios.put(
    `${API_URL}/api/ferias/proveedores/${id}`,
    body,
    { headers: auth() },
  );
  return data;
};

export const uploadFeriaProveedorFoto = async (id, file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(
    `${API_URL}/api/ferias/proveedores/${id}/foto`,
    form,
    {
      headers: { ...auth(), "Content-Type": "multipart/form-data" },
    },
  );
  return data;
};

export const addFeriaMaterial = async (edicionId, body) => {
  const { data } = await axios.post(
    `${API_URL}/api/ferias/ediciones/${edicionId}/materiales`,
    body,
    { headers: auth() },
  );
  return data;
};

export const updateFeriaMaterial = async (id, body) => {
  const { data } = await axios.put(
    `${API_URL}/api/ferias/materiales/${id}`,
    body,
    {
      headers: auth(),
    },
  );
  return data;
};

export const deleteFeriaMaterial = async (id) => {
  await axios.delete(`${API_URL}/api/ferias/materiales/${id}`, {
    headers: auth(),
  });
};

export const extractFeriaFoto = async (file, kind) => {
  const form = new FormData();
  form.append("file", file);
  form.append("kind", kind);
  const { data } = await axios.post(`${API_URL}/api/ferias/extract`, form, {
    headers: { ...auth(), "Content-Type": "multipart/form-data" },
  });
  return data;
};

/** Absolute URL for feria session media (`/uploads/ferias/...`). */
export const feriaSessionMediaUrl = (fileUrl) => {
  if (!fileUrl) return "";
  if (/^(https?:|blob:|data:)/i.test(fileUrl)) return fileUrl;
  const base = String(API_URL || "").replace(/\/$/, "");
  return `${base}${fileUrl.startsWith("/") ? "" : "/"}${fileUrl}`;
};

/** Original a tamaño completo (visor / Vision). */
export const feriaPhotoDisplayUrl = (photo) => {
  if (!photo) return "";
  if (photo._localPreview) return photo._localPreview;
  return feriaSessionMediaUrl(photo.fileUrl || "");
};

/**
 * Mosaico: prioriza thumb del back (como Meetings).
 * Sin thumb → fileUrl / blob local. Vídeo sin thumb → vacío.
 */
export const feriaPhotoThumbUrl = (photo) => {
  if (!photo) return "";
  if (photo._localPreview) return photo._localPreview;
  if (photo.thumbUrl) return feriaSessionMediaUrl(photo.thumbUrl);
  const mime = String(photo.mimeType || "").toLowerCase();
  const video =
    photo.kind === "video" ||
    mime.startsWith("video/") ||
    /\/videos\//i.test(String(photo.fileUrl || ""));
  if (video) return "";
  return feriaSessionMediaUrl(photo.fileUrl || "");
};

export const patchFeriaMediaGroups = async (edicionId, mediaGroups) => {
  const { data } = await axios.patch(
    `${API_URL}/api/ferias/ediciones/${edicionId}/media-groups`,
    { mediaGroups },
    { headers: auth() },
  );
  return data;
};

export const uploadFeriaEdicionPhoto = async (
  edicionId,
  file,
  { caption, offsetMs, groupId, capturedAt } = {},
) => {
  const form = new FormData();
  form.append("file", file);
  if (caption) form.append("caption", caption);
  if (offsetMs != null) form.append("offsetMs", String(offsetMs));
  if (groupId) form.append("groupId", String(groupId));
  if (capturedAt) form.append("capturedAt", capturedAt);
  const { data } = await axios.post(
    `${API_URL}/api/ferias/ediciones/${edicionId}/photos`,
    form,
    { headers: { ...auth(), "Content-Type": "multipart/form-data" } },
  );
  return data;
};

export const patchFeriaPhoto = async (photoId, body) => {
  const { data } = await axios.patch(
    `${API_URL}/api/ferias/photos/${photoId}`,
    body,
    { headers: auth() },
  );
  return data;
};

export const deleteFeriaPhoto = async (photoId) => {
  const { data } = await axios.delete(
    `${API_URL}/api/ferias/photos/${photoId}`,
    { headers: auth() },
  );
  return data;
};

/** Blob autenticado de una foto de sesión (para Vision / alta material). */
export const downloadFeriaPhotoBlob = async (
  photoId,
  { thumb = false } = {},
) => {
  const { data } = await axios.get(
    `${API_URL}/api/ferias/photos/${photoId}/file${thumb ? "?thumb=1" : ""}`,
    { headers: auth(), responseType: "blob" },
  );
  return data;
};

export const linkFeriaPhotosMaterialoteca = async (edicionId, body) => {
  const { data } = await axios.post(
    `${API_URL}/api/ferias/ediciones/${edicionId}/photos/link-materialoteca`,
    body,
    { headers: auth() },
  );
  return data;
};

export const unlinkFeriaPhotosMaterialoteca = async (edicionId, body) => {
  const { data } = await axios.post(
    `${API_URL}/api/ferias/ediciones/${edicionId}/photos/unlink-materialoteca`,
    body,
    { headers: auth() },
  );
  return data;
};

export const createFeriaFreeNote = async (edicionId, bodyText) => {
  const { data } = await axios.post(
    `${API_URL}/api/ferias/ediciones/${edicionId}/notes`,
    { body: bodyText },
    { headers: auth() },
  );
  return data;
};

export const patchFeriaFreeNote = async (edicionId, noteId, bodyText) => {
  const { data } = await axios.patch(
    `${API_URL}/api/ferias/ediciones/${edicionId}/notes/${noteId}`,
    { body: bodyText },
    { headers: auth() },
  );
  return data;
};

export const deleteFeriaFreeNote = async (edicionId, noteId) => {
  await axios.delete(
    `${API_URL}/api/ferias/ediciones/${edicionId}/notes/${noteId}`,
    { headers: auth() },
  );
};

export const listFeriaAudioChunks = async (edicionId) => {
  const { data } = await axios.get(
    `${API_URL}/api/ferias/ediciones/${edicionId}/audio-chunks`,
    { headers: auth() },
  );
  return data;
};

export const uploadFeriaAudioChunk = async (
  edicionId,
  file,
  { seq, durationMs } = {},
) => {
  const form = new FormData();
  form.append("file", file);
  if (seq != null) form.append("seq", String(seq));
  if (durationMs != null) form.append("durationMs", String(durationMs));
  const { data } = await axios.post(
    `${API_URL}/api/ferias/ediciones/${edicionId}/audio-chunks`,
    form,
    { headers: { ...auth(), "Content-Type": "multipart/form-data" } },
  );
  return data;
};

export const summarizeFeriaEdicion = async (edicionId) => {
  const { data } = await axios.post(
    `${API_URL}/api/ferias/ediciones/${edicionId}/summarize`,
    {},
    { headers: auth(), timeout: 120000 },
  );
  return data;
};
